import type {
  AskUserQuestionArgs,
  AskUserQuestionArgsInput,
  AskUserQuestionItem,
  AskUserQuestionItemInput,
  AskUserQuestionOption,
  AskUserQuestionOptionInput,
} from "./types";

export const getAskUserQuestionOptionLabel = (
  option: AskUserQuestionOptionInput,
): string => {
  return typeof option === "string" ? option : option.label;
};

export const normalizeAskUserQuestionOption = (
  option: AskUserQuestionOptionInput,
): AskUserQuestionOption => {
  if (typeof option === "string") {
    return { label: option, recommended: false };
  }

  return {
    label: option.label,
    recommended: Boolean(option.recommended),
  };
};

const normalizeAskUserQuestionItem = (
  item: AskUserQuestionItemInput,
): AskUserQuestionItem => ({
  ...item,
  options: (item.options ?? []).map(normalizeAskUserQuestionOption),
});

export const normalizeAskUserQuestionArgs = (
  args: AskUserQuestionArgsInput,
): AskUserQuestionArgs => ({
  questions: args.questions.map(normalizeAskUserQuestionItem),
});
